import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSms,
  faCalendarCheck,
  faCalendarMinus,
  faCalendarTimes,
  faCalendar,
  faEnvelope
} from '@fortawesome/free-solid-svg-icons'

import DateFormat, { dateHasPast } from '../../../utils/dateFormat'

import { AdminTd, AdminTh, AdminTable } from '../../Tables'
import { Link } from 'react-router-dom'

const Requests = () => {
  const user = useSelector(store => store.admin.user)

  if (!user.availabilityRequests) {
    return <></>
  }

  return (
    <>
      <AdminTable>
        <thead>
          <tr>
            <AdminTh>Status</AdminTh>
            <AdminTh>Facility</AdminTh>
            <AdminTh>Dates</AdminTh>
            <AdminTh>Nights</AdminTh>
            <AdminTh>Sites</AdminTh>
            <AdminTh>Pref</AdminTh>
            <AdminTh>
              Matches
              <br />
              Active / Total
            </AdminTh>
            <AdminTh>
              Notifications
              <br />
              24hr / All
            </AdminTh>
            <AdminTh>Checked</AdminTh>
            <AdminTh>Checked At</AdminTh>
            <AdminTh>Created At</AdminTh>
          </tr>
        </thead>
        <tbody>
          {user.availabilityRequests.map(ar => (
            <tr key={ar.uuid}>
              <AdminTd>
                <a href={`/${ar.uuid}`}>
                  {ar.status === 'active' && !dateHasPast(ar.dateEnd) && (
                    <FontAwesomeIcon icon={faCalendarCheck} className="text-xl text-green-700" />
                  )}
                  {ar.status === 'active' && dateHasPast(ar.dateEnd) && (
                    <FontAwesomeIcon icon={faCalendarMinus} className="text-xl text-orange-400" />
                  )}
                  {ar.status === 'canceled' && (
                    <FontAwesomeIcon icon={faCalendarTimes} className="text-xl text-red-700" />
                  )}
                  {ar.status === 'paused' && !dateHasPast(ar.dateEnd) && (
                    <FontAwesomeIcon icon={faCalendar} className="text-xl text-green-200" />
                  )}
                </a>
              </AdminTd>
              <AdminTd>
                <Link to={`/f/${ar.facility.slug}`}>{ar.facility.name}</Link>
              </AdminTd>
              <AdminTd>
                <DateFormat format="MM/DD" date={ar.dateStart} />
                &nbsp;-&nbsp;
                <DateFormat format="MM/DD/YYYY" date={ar.dateEnd} />
              </AdminTd>
              <AdminTd>{ar.stayLength}</AdminTd> <AdminTd>{ar.siteCount}</AdminTd>
              <AdminTd>
                <span className="flex space-x-2">
                  {ar.notifySms && <FontAwesomeIcon icon={faSms} className="text-xl text-gray-400" />}
                  {ar.notifyEmail && <FontAwesomeIcon icon={faEnvelope} className="text-xl text-gray-400" />}
                </span>
              </AdminTd>
              <AdminTd>
                {ar.matchesAvailabileCount} / {ar.matchesCount}
              </AdminTd>
              <AdminTd>
                {ar.availabilityNotifications24Count} / {ar.availabilityNotificationsCount}
              </AdminTd>
              <AdminTd>{ar.checkedCount}</AdminTd>
              <AdminTd>{ar.checkedAt && <DateFormat format="M/D/YYYY hh:mm" date={ar.checkedAt} />}</AdminTd>
              <AdminTd>{ar.createdAt && <DateFormat format="M/D/YYYY hh:mm" date={ar.createdAt} />}</AdminTd>
            </tr>
          ))}
        </tbody>
      </AdminTable>

      <div className="flex space-x-6 mt-8 text-xl font-semibold">
        <span>Status Key:</span>
        <span>
          <FontAwesomeIcon icon={faCalendarCheck} className="text-xl text-green-700" /> Active
        </span>
        <span>
          <FontAwesomeIcon icon={faCalendarMinus} className="text-xl text-orange-400" /> Active - Expired (End date
          passed)
        </span>
        <span>
          <FontAwesomeIcon icon={faCalendarTimes} className="text-xl text-red-700" /> Canceled
        </span>
        <span>
          <FontAwesomeIcon icon={faCalendar} className="text-xl text-green-200" /> Paused
        </span>
      </div>
    </>
  )
}
// {dateHasPast(ar.dateEnd) && <> - Expired // Date Has Past</>}
export default Requests
